var render = function render(){var _vm=this,_c=_vm._self._c;return _c('buddhism-enroll-list',{ref:"buddhismList",staticClass:"piece-area buddha-order-list",attrs:{"type":"claim"}})
}
var staticRenderFns = []

export { render, staticRenderFns }